export default "__VITE_ASSET__BTZ02183__"